import * as React from 'react';
import type { JSX } from 'react';
import { ArticleHeading1, Responsive, UIHeading2 } from '@cian/ui-kit';

import * as styles from './AboutBlockLayout.css';

type TAboutBlockLayoutProps = {
  testId?: string;
  title: string;
  content: JSX.Element;
};

export const AboutBlockLayout: React.FC<TAboutBlockLayoutProps> = ({ title, content, testId }) => {
  return (
    <div className={styles['container']} data-testid={testId}>
      <Responsive desktop>
        <ArticleHeading1>{title}</ArticleHeading1>
      </Responsive>
      <Responsive phone tablet>
        <UIHeading2>{title}</UIHeading2>
      </Responsive>
      {content}
    </div>
  );
};
